import {
  Datagrid,
  TextField,
  EditButton,
  DeleteButton,
  Filter,
  TextInput,
  NumberInput,
  ReferenceField,
} from "react-admin";

import resources from "../../constants/resources";
import { ListStyles } from "../../styles/commonStyles";

const ContentTagFilter = props => (
  <Filter {...props}>
    <NumberInput label="ID" source="id" />
    <TextInput label="Key" source="key" />
    <TextInput label="Value" source="value" />
    <NumberInput label="Content" source="content" />
  </Filter>
);

const ContentTagList = props => (
  <ListStyles
    {...props}
    title={resources.CONTENT_TAGS.title}
    perPage={25}
    exporter={false}
    filters={<ContentTagFilter />}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" />
      <ReferenceField
        label={resources.CONTENT.label}
        source="content"
        sortable={false}
        reference={resources.CONTENT.url}
      >
        <TextField source="name_en" />
      </ReferenceField>
      <TextField source="key" sortable={false} />
      <TextField source="value" sortable={false} />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </ListStyles>
);

export default ContentTagList;
